import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "HomePage",
    meta: { index: 1, title: "小君直播" },
    component: () => import("../views/HomePage.vue"),
  },
  {
    path: "/LiveSharing",
    name: "webShare",
    component: () => import("../views/webShare.vue"),
  },
  {
    path: "/ceshi",
    name: "ceshi",
    component: () => import("../views/ceshi.vue"),
  },
  {
    path: "/shopCard",
    name: "shopCard",
    component: () => import("../views/shopCard.vue"),
  },
  {
    path: "/live",
    name: "live",
    component: () => import("../views/live.vue"),
  },
  {
    path: "/application",
    name: "live",
    component: () => import("../views/application.vue"),
  },
  {
    path: "/middlePage",
    name: "middlePage",
    component: () => import("../views/middlePage.vue"),
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
